import axios from "axios";
const local_url = "http://localhost:30022/api";

const remote_url = local_url;
// Base configuration for all API requests
export const apiClient = axios.create({
  baseURL: remote_url,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor for adding the token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Request OTP endpoint
export const createAccount = async (email, password, role, firstName, lastName, interests, bio, website) => {
  try {
    const payload = { email, password, role, firstName, lastName, interests, bio, website };
    const response = await apiClient.post("/elearn/auth/create-account", payload);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Login endpoint
export const loginUser = async (email, password) => {
  try {
    const payload = { email, password };
    const response = await apiClient.post("/elearn/auth/login", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

// Login endpoint
export const forgotPassword = async (email) => {
  try {
    const payload = { email };
    const response = await apiClient.post("/elearn/auth/request-password-reset", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const payload = { token, newPassword };
    const response = await apiClient.post("/elearn/auth/reset-password", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

// Fetch user profile
export const fetchWalletDetails = async () => {
  try {
    const response = await apiClient.get("/elearn/get-wallet");
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

// Make investment
export const investDeposit = async (currency) => {
  try {
    const payload = { currency };
    const response = await apiClient.post("/elearn/transfer/invest", payload);
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const massWithdrawal = async () => {
  try {
    const response = await apiClient.post("/elearn/mass-withdrawal");
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const transferReferral = async (amount, destination) => {
  try {
    const payload = { amount, destination };
    const response = await apiClient.post(
      "/elearn/transfer/referral",
      payload
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const withdrawFunds = async (receiverAddress, amount, currency) => {
  try {
    const payload = { receiverAddress, amount, currency };
    const response = await apiClient.post("/elearn/withdraw", payload);
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

// Fetch user profile
export const fetchUserProfile = async () => {
  try {
    const response = await apiClient.get("/elearn/auth/me");
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

// Fetch user profile
export const fetchTransactionHistory = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get(
      `/elearn/transactions/get-transactions?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const fetchUserTransactionHistory = async (query = "") => {
  try {
    const response = await apiClient.get(
      `/elearn/transactions/user-transactions${query}`
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const fetchReferralsStages = async () => {
  try {
    const response = await apiClient.get("/elearn/referrals/get-referrals");
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const fetchReferralsDetails = async () => {
  try {
    const response = await apiClient.get(
      "/elearn/referrals/get-referrals-earnings"
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const fetchReferredUsers = async () => {
  try {
    const response = await apiClient.get(
      "/elearn/referrals/get-referred-users"
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const transferReferralsBalance = async () => {
  try {
    const response = await apiClient.post("/elearn/transfer/referral");
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const fetchAllInvestment = async () => {
  try {
    const response = await apiClient.get("/elearn/investments");
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const alltransactions = async (query = "") => {
  try {
    const response = await apiClient.get(
      `/elearn/transactions/admin-only-transactions${query}`
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const depositTotals = async () => {
  try {
    const response = await apiClient.get(
      `/elearn/transactions/deposits-total`
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const withdrawalTotals = async () => {
  try {
    const response = await apiClient.get(
      `/elearn/transactions/withdrawals-total`
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const investmentTotals = async () => {
  try {
    const response = await apiClient.get(
      `/elearn/transactions/investment-total`
    );
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const getTotalUsers = async () => {
  try {
    const response = await apiClient.get(`/elearn/users`);
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const fetchAllUserInvestment = async () => {
  try {
    const response = await apiClient.get("/elearn/investments/user");
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const submitLoanApplication = async (loanData) => {
  try {
    const response = await apiClient.post("/elearn/borrow/request", loanData);
    return response.data;
  } catch (error) {
    console.error(
      "Loan submission failed:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const verifyApplicationFeePayment = async () => {
  try {
    const response = await apiClient.post(
      "/elearn/borrow/application-fee/pay"
    );
    return response.data;
  } catch (error) {
    console.error(
      "Payment verification failed:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getMyLoanRequests = async () => {
  try {
    const response = await apiClient.get("/elearn/borrow/user");
    const data = response.data?.borrowRequest;

    if (Array.isArray(data)) {
      return { requests: data };
    } else if (data && typeof data === "object") {
      return { requests: [data] };
    } else {
      return { requests: [] };
    }
  } catch (error) {
    console.error(
      "Error fetching user loan requests:",
      error.response?.data || error.message
    );
    return { requests: [] };
  }
};

export const checkApplicationFeeStatus = async () => {
  try {
    const response = await apiClient.get(
      "/elearn/borrow/application-fee/user"
    );
    return response.data.fee;
  } catch (error) {
    console.error(
      "Application fee status check failed:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const fetchAllWallet = async () => {
  try {
    const response = await apiClient.get("/elearn/get-all-wallet");
    return response.data;
  } catch (error) {
    console.error(
      "Failed to wallet details:",
      error.response?.data || error.message
    );
    throw error;
  }
};
